export default "__VITE_ASSET__rs6mLkOG__"